import {ChangeDetectionStrategy, Component, computed, input} from '@angular/core';
import {OpenHourGrouped} from '../../../types/OpenHourGrouped';
import {OpenHourFieldNameTypesEnum, OpenHourTypeLabelsEnum} from '../../../enums/BookingEnums';
import {CareproviderHelper} from '../../../services/careprovider.helper';
import {ToolsService} from '../../../services/tools.service';

interface OpenHourToDisplay {
  id: number;
  days: string;
  hours: string;
  comment?: string;
  isCommentOnly: boolean;
}

@Component({
  selector: 'app-cpru-open-hours',
  templateUrl: './cpru-open-hours.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col gap-8 md:rounded-lg md:border md:border-grey-9 md:bg-white md:px-4 md:py-5',
  },
})
export class CpruOpenHoursComponent {
  public serviceHours = input<OpenHourGrouped>(null);
  protected surHours = computed<OpenHourToDisplay[]>((): OpenHourToDisplay[] =>
    this.filterOpenHours(this.serviceHours(), OpenHourFieldNameTypesEnum.SURGERY),
  );
  protected telHours = computed<OpenHourToDisplay[]>((): OpenHourToDisplay[] =>
    this.filterOpenHours(this.serviceHours(), OpenHourFieldNameTypesEnum.TELEPHONE),
  );
  protected droHours = computed<OpenHourToDisplay[]>((): OpenHourToDisplay[] =>
    this.filterOpenHours(this.serviceHours(), OpenHourFieldNameTypesEnum.DROPIN),
  );
  protected visHours = computed<OpenHourToDisplay[]>((): OpenHourToDisplay[] =>
    this.filterOpenHours(this.serviceHours(), OpenHourFieldNameTypesEnum.VISITINGHOURS),
  );
  protected readonly OpenHourTypeLabelsEnum = OpenHourTypeLabelsEnum;

  constructor(
    private careproviderHelper: CareproviderHelper,
    private tools: ToolsService,
  ) {}

  private filterOpenHours(hours: OpenHourGrouped, key: OpenHourFieldNameTypesEnum): OpenHourToDisplay[] {
    if (this.tools.isNil(hours) || this.tools.isNil(hours[key])) {
      return [];
    }
    return hours[key]
      .filter((hour) => hour.fromDay > 0 && hour.toDay > 0)
      .map((hour) => {
        const days = this.careproviderHelper.getOpenningDays(hour);
        const hours = this.careproviderHelper.getOpenningHours(hour);
        const item: OpenHourToDisplay = {
          id: hour.id,
          days,
          hours,
          comment: hour.comment,
          isCommentOnly: hour.isCommentOnly,
        };
        return item;
      });
  }
}
